import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BoardingPassIssueHpbpEffect } from './boarding-pass-issue-hpbp.effect';
import { boardingPassIssueHpbpReducer } from './boarding-pass-issue-hpbp.reducer';
import { BOARDING_PASS_ISSUE_HPBP_STORE_NAME, BoardingPassIssueHpbpState } from './boarding-pass-issue-hpbp.state';

/** Token of the BoardingPassIssueHpbp reducer */
export const BOARDING_PASS_ISSUE_HPBP_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<BoardingPassIssueHpbpState, Action>
>('Feature BoardingPassIssueHpbp Reducer');

/** Provide default reducer for BoardingPassIssueHpbp store */
export function getDefaultBoardingPassIssueHpbpReducer() {
  return boardingPassIssueHpbpReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(BOARDING_PASS_ISSUE_HPBP_STORE_NAME, BOARDING_PASS_ISSUE_HPBP_REDUCER_TOKEN),
    EffectsModule.forFeature([BoardingPassIssueHpbpEffect]),
  ],
  providers: [{ provide: BOARDING_PASS_ISSUE_HPBP_REDUCER_TOKEN, useFactory: getDefaultBoardingPassIssueHpbpReducer }],
})
export class BoardingPassIssueHpbpStoreModule {
  public static forRoot<T extends BoardingPassIssueHpbpState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<BoardingPassIssueHpbpStoreModule> {
    return {
      ngModule: BoardingPassIssueHpbpStoreModule,
      providers: [{ provide: BOARDING_PASS_ISSUE_HPBP_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
